import { useRouter } from 'vue-router';

export function useSearchAction() {
  const router = useRouter();

  function handleSubmit(event) {
    event.preventDefault();
    const searchValue = event.target.querySelector('input').value;
    if (searchValue?.length === 0) {
      alert('조회할 키워드를 입력해주세요.')
    } else {
      window.location.href = `/company?s=${encodeURIComponent(searchValue)}`
    }
    event.target.reset();
  }

  return {
    handleSubmit,
  };
}